<script>

import CMultiSelectElement from './CMultiSelectElement.vue'

const props = {
  name: String,
  form: String,
  text: String,
  value: String,
  ulClass: String,
  items: Array,
  type: String   //'div' | 'select'
}

export default {
  name: 'CMultiSelectRender',
  functional: true,
  props,
  components: {
    CMultiSelectElement,
  },
  data: function () {
    return {}
  },
  methods: {},
  render: function (h, context) {
    let selectItem = context.listeners['select-item']
    let closeSelect = context.listeners['close-select']
    let result = []
    const buildElementBlocks = function (el, ul, self, label) {
      let innerResult = []
      if (label != null) {
        result = h(CMultiSelectElement, {
          props: {
            type: 'c-label',
            label: label,
            eltype: context.props.type,
          }
        }, result)
        return result
      }
      if (typeof el.label === 'undefined' && typeof el.value === 'undefined') {  //root
        if (context.props.type === 'select')
          innerResult.push(buildElementBlocks({
            text: 'Select...',
            value: '',
            visible: true,
            eltype: context.props.type,
            selected: false,
          }, false, self, null))
        for (let i = 0; i < el.options.length; i++) {
          innerResult.push(buildElementBlocks(el.options[i], true, self, null))
        }
        result = h(CMultiSelectElement, {
          props: {
            type: 'root',
            ulClass: context.props.ulClass,
            eltype: context.props.type,
            name: context.props.name,
            form: context.props.form
          }
        }, innerResult)
      } else if (typeof el.label !== 'undefined') {  //ul
        innerResult.push(buildElementBlocks(null, null, self, el.label))
        for (let i = 0; i < el.options.length; i++) {
          innerResult.push(buildElementBlocks(el.options[i], true, self, null))
        }
        result = h(CMultiSelectElement, {
          props: {
            type: 'ul',
            eltype: context.props.type,
            label: el.label,
          }
        }, innerResult)
      } else {   //li
        result = h(CMultiSelectElement, {
          props: {
            type: 'li',
            text: el.text,
            value: el.value,
            visible: el.visible,
            eltype: context.props.type,
            selected: el.selected,
          },
          on: {
            selectitem: function (a, b, c) {
              // console.log('selectitem', a, b,c)
              selectItem(a, b, c)
            },
            closeselect: function () {
              // console.log('closeselect')
              closeSelect()
            }
          }
        })
      }
      return result
    }
    if (typeof context.props.items != 'undefined' && typeof context.props.items[0] != 'undefined') {
      result = buildElementBlocks(context.props.items[0], true, this, null)
    }
    return result
  }
}

</script>
